<template>
  <PrimevuePanel class="  border-solid border-1 surface-border">

    <!-- <div v-if="!this.$props.communication" class="mb-2 font-medium text-xl">{{this.$props.message.subject}}</div> -->
    <template #header>
      <div class="flex align-items-center">
        <span class="font-bold">Odpoveď</span>
      </div>
    </template>
    <template #icons>

    </template>
    <form @submit.prevent="onSendEmail" name="emailForm">
      <div class="flex flex-wrap">
        <div class="w-full">
          <!--
              <div class="formgrid grid">
                  <div class="col-2 flex align-items-end">
                      <em class="ml-3  text-500">Komu</em>
                  </div>
                  <div class=" col-10">
                      <input class="input-email w-full"
                          :class="`${v$.email.$error ? 'border-red-500' : ''}`"

                          v-model="email"
                          type="text"
                          name="email"
                          id="email"
                      >

                  <div
                      v-for="(error, index) of v$.email.$errors"
                      :key="index"
                      class="text-xs font-italic text-red-400"
                  >
                      {{ error.$message }}
                  </div>
                  </div>
              </div>
          -->
          <div class="flex flex-row gap-2 align-items-center mb-2">
            <div class="flex-1">
              <div class="formgrid grid">
                <div class="col-2 pt-1">
                  <em class="text-500">Predmet</em>
                </div>
                <div class="col-10">
                  <input class="input-email w-full"
                         v-model="subject"
                         type="text"
                         name="subject"
                         id="subject"
                  >
                </div>
              </div>
            </div>
            <div class="flex-1">
              <FileUpload name="files[]" url="" :multiple="true" :maxFileSize="10000000" :customUpload="true"
                          @select="onSelectedFiles">

                <template #header="{ chooseCallback,clearCallback }">

                  <PrimevueSelect
                      id="select-att-type"
                      
                      v-model="this.selectedAttType"
                      :options="store.attTypes"
                      optionLabel="name"
                      placeholder="Pridaj prílohu výberom jej typu"
                      class="w-10"
                      @change="chooseCallback()"
                  >
                      <template #value="slotProps">
                          <div v-if="slotProps.value" class="">
                              <div>{{ slotProps.value.name }}</div>
                          </div>
                          <span v-else>
                          {{ slotProps.placeholder }}
                          </span>
                      </template>
                      <template #option="slotProps">
                          <div class="">
                              <div>{{ slotProps.option.name }}</div>
                          </div>
                      </template>
                  </PrimevueSelect>  

                  <!-- <div class="flex flex-wrap justify-content-between align-items-center flex-1 gap-2">
                      <div class="flex gap-2"> 
                  <PrimevueButton @click="chooseCallback()" v-tooltip.top="{ value: 'Priloženie prílohy k mailu' }"
                                  icon="pi pi-paperclip" text size="large"></PrimevueButton>
                  -->
                  <div ref="emailDiv" @afterEmailSend="clearCallback()"></div>
                </template>

                <template #content="{ files, removeFileCallback }">

                  <div v-if="files.length > 0">

                    <div class="ml-3 pt-1 pb-1 flex flex-wrap gap-1">
                      <div v-for="(file, index) of files" :key="file.name + file.type + file.size"
                           class="shadow-2 p-1 flex surface-card w-10rem">
                        <div class="w-10">

                          <div class="text-700 text-base font-medium mb-1">
                              {{ this.attTypes[index].name }} 
                          </div>
                          <div class="text-500 text-sm font-medium overflow-hidden text-overflow-ellipsis">
                            {{ file.name }}
                          </div>
                          <div class="text-400 text-xs">{{ formattedFileSize(file.size) }}</div>

                        </div>
                        <div class="w-2 align-items-center flex">
                          <PrimevueButton class="file-danger" icon="pi pi-times"
                                          @click="onRemoveTemplatingFile(file, removeFileCallback, index)" severity="danger"/>
                        </div>
                      </div>


                    </div>

                  </div>


                </template>
                <!--
                <template #empty>
                  <div class="ml-3">
                    <p class="flex mt-0 mb-0">Potiahnutím sem pridáte súbory</p>
                  </div>
                </template>
                -->
              </FileUpload>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- <div class="mt-1 mb-1 border-solid border-1 surface-border"></div> -->
    <PrimevueEditor v-model="text" @text-change="textChange" editorStyle="height: 10rem" class="mt-2">
      <template v-slot:toolbar>
            <span class="ql-formats">
                <button v-tooltip.bottom="'Bold'" class="ql-bold"></button>
                <button v-tooltip.bottom="'Italic'" class="ql-italic"></button>
                <button v-tooltip.bottom="'Underline'" class="ql-underline"></button>
                
            </span>
        <span class="ql-formats">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
            </span>

        <select class="ql-align">
          <option selected></option>
          <option value="center"></option>
          <option value="right"></option>
          <option value="justify"></option>
        </select>
        <select class="ql-size">
          <option value="small"></option>
          <option selected></option>
          <option value="large"></option>
          <option value="huge"></option>
        </select>
      </template>
    </PrimevueEditor>
    <div class="mt-2 flex justify-content-start">
      <PrimevueButton @click="onSendEmail" v-tooltip.top="{ value: 'Zaslanie mailu' }" icon="pi pi-send"
                      size="large" label="Odoslať" iconPos="left" style="padding: 0.75rem 1.5rem;"></PrimevueButton>
    </div>
  </PrimevuePanel>
</template>

<script lang="ts">
import Security from './security'
import {store} from './store'
import notie from "notie/dist/notie";
//import Utils from '@/components/utils';
import FileUpload from 'primevue/fileupload';
import PrimevuePanel from 'primevue/panel';
import PrimevueEditor from 'primevue/editor';
import PrimevueButton from "primevue/button";
import PrimevueSelect from "primevue/dropdown";
import {emiter} from '../main';
//import router from "@/router";

export default {
  name: 'EditorMessage',
  components: {
    FileUpload,
    PrimevuePanel,
    PrimevueEditor,
    PrimevueButton,
    PrimevueSelect,
  },
  props: {
    orderId: String,
    orderDesc: String,
    orderCode: String,
  },
  data() {
    return {
      store,
      files: [],
      text: "",
      subject: "",
      textValue: "",
      htmlValue: "",
      attTypes: [],
      selectedAttType: null
    }
  },
  //setup () {
  //  return {
  //      v$: useVuelidate()
  //    }
  //},
  //validations () {
  //    return {
  //      email:  {required: helpers.withMessage('Email nesmie byť prázdny', required),
  //               email: helpers.withMessage('Nesprávny email', email)},
  //
  //    }
  //},
  methods: {
    deleteData() {
      this.$nextTick(() => {
        const emailDiv = this.$refs.emailDiv;
        emailDiv.dispatchEvent(new CustomEvent('afterEmailSend'));
      });

      this.files = []
      //console.log("Delete:", this.files)
      this.text = ""
      this.textValue = ""
      this.htmlValue = ""
      //this.email = ""
      this.subject = ""
      this.attTypes = []
    },

    formattedFileSize(fileSize: number): string {
      //const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      //if (fileSize == 0) return '0 KB';
      //const i = Math.floor(Math.log(this.fileSize) / Math.log(1024));
      return Math.round(fileSize / Math.pow(1024, 1)) + ' KB'; //sizes[i];
    },

    onRemoveTemplatingFile(file, removeFileCallback, index) {

      removeFileCallback(index);
      this.attTypes.splice(index,1);

    },

    onSelectedFiles(event) {
      this.attTypes.push(this.selectedAttType);
      this.selectedAttType = null
      this.files = event.files;

    },

    async onSendEmail() {
      //console.log("Files:", this.files)

      //const result = await this.v$.$validate()
      //if (!result) {
      // notify user form is invalid
      //    return
      //}
      this.sendEmail()
    },

    sendEmail() {
      const formData = new FormData();

      formData.append("subject", this.subject);
      formData.append("bodyHtml", this.htmlValue);
      formData.append("bodyText", this.textValue);
      formData.append("orderId", this.orderId);
      this.attTypes.forEach((type) => {
                formData.append('attTypes', String(type.id));
      });
      this.files.forEach((file) => {
        formData.append("files", file);
      });

      //this.deleteData();

      fetch(
          store.Api_url + "/send-email",
          Security.requestMultipartOptions("POST", formData)
      )
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              //console.log("Error:", responseData)
              notie.alert({
                type: "error",
                text: responseData.data.message,
                position: "bottom",
              });
            } else {
              notie.alert({
                type: "success",
                text: "Email bol úspešne odoslaný",
              });

              this.deleteData();
              emiter.emit("reloadAttByType");
            }
          });
    },


    textChange(event) {
      //console.log(event)
      this.textValue = event.textValue
      this.htmlValue = event.htmlValue
      //const formData = new FormData();
    },

    getCode(){
      return ` [Pifema #${this.orderCode}]`
    }
  },
  beforeMount() {
    Security.requireToken();
    store.selectModul = this.$route.path.split("/")[1];

    // Initialize the email content
    const additionalTextHtml = `<br><br><p>V tejto komunikácii používajte prosím kód ${this.getCode()}</p>`;
    const additionalTextPlain = `\n\n V tejto komunikácii používajte prosím kód ${this.getCode()}`;

    this.subject = `Re: ${this.orderDesc} ${this.getCode()}`;
    this.htmlValue = additionalTextHtml;
    this.textValue = additionalTextPlain;
    this.text = additionalTextPlain; // Display the text in the editor
  },
  watch: {
    orderCode(newVal) {
      this.subject = `Re: ${this.orderDesc} ${this.getCode()}`;

      const additionalTextHtml = `<br><br><p>V tejto komunikácii používajte prosím kód ${this.getCode()}</p>`;
      const additionalTextPlain = `\n\n V tejto komunikácii používajte prosím kód ${this.getCode()}`;

      this.htmlValue = additionalTextHtml;
      this.textValue = additionalTextPlain;
      this.text = additionalTextPlain; // Update the editor content
    },
  },
}
</script>